import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/results_analytics_event.py
export const RESULTS_ANALYTICS_ACTIONS = {
  // READ actions
  CHANGED_RUNS_INBOX_ARCHIVE_FILTER: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'changed_runs_inbox_archive_filter',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CHANGED_RUNS_INBOX_IN_ENTRY_FILTER: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'changed_runs_inbox_in_entry_filter',
    actionCategory: ACTION_CATEGORY.READ,
  },
  DOWNLOADED_DATA_TABLE_AS_CSV: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'downloaded_data_table_as_csv',
    actionCategory: ACTION_CATEGORY.READ,
  },
  EXPORTED_BIOENTITY_RESULTS: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'exported_bioentity_results',
    actionCategory: ACTION_CATEGORY.READ,
  },
  EXPORTED_REQUEST_RESULTS: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'exported_request_results',
    actionCategory: ACTION_CATEGORY.READ,
  },
  READ_ENTRY_WITH_ASSAY_DATA: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'read_entry_with_assay_data',
    actionCategory: ACTION_CATEGORY.READ,
  },
  EXPORTED_RUN_RESULTS: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'exported_run_results',
    actionCategory: ACTION_CATEGORY.READ,
  },
  HOVERED_VALIDATION_TRIANGLE: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'hovered_validation_triangle',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_CONFIGURE_RESULT_TABLE_MODAL: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'opened_configure_result_table_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_RUN_INBOX: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'opened_run_inbox',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_VALIDATION_HISTORY_MODAL: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'opened_validation_history_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  // WRITE actions
  ARCHIVED_AUTOMATION_OUTPUT_FILE: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'archived_automation_output_file',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ARCHIVED_RUN_FROM_INBOX: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'archived_run_from_inbox',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ATTACHED_ASSAY_DATA_IN_ENTRY: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'attached_assay_data_in_entry',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ARCHIVED_ENTRY_WITH_RESULTS: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'archived_entry_with_results',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_ASSAY_SCHEMA: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'created_assay_schema',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_RUN: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'created_run',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  COMPUTED_SNAPSHOT_FIELD: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'computed_snapshot_field',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  FINISHED_TRANSFORM_CONFIGURATION: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'finished_transform_configuration',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  INSERTED_DATA_TABLE: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'inserted_data_table',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  INSERTED_RUN_FROM_INBOX: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'inserted_run_from_inbox',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  PUBLISHED_DATA_TABLE_CONFIG: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'published_data_table_config',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_ASSAY_SCHEMA: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'updated_assay_schema',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_DATA_TABLE: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'updated_data_table',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_INPUT_FILE_CONFIG: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'updated_input_file_config',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_OUTPUT_FILE_CONFIG: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'updated_output_file_config',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_RUN: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'updated_run',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPLOADED_RUN_RESULTS: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'uploaded_run_results',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SET_CELL_VALIDATION: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'set_cell_validation',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SET_ROW_VALIDATION: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'set_row_validation',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SET_RUN_VALIDATION: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'set_run_validation',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  STARTED_AUTOMATION_INPUT_FILE: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'started_automation_input_file',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  STARTED_AUTOMATION_OUTPUT_FILE: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'started_automation_output_file',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  STARTED_TRANSFORM_CONFIGURATION: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'started_transform_configuration',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UNARCHIVED_AUTOMATION_OUTPUT_FILE: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'unarchived_automation_output_file',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UNARCHIVED_RUN_FROM_INBOX: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'unarchived_run_from_inbox',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SET_CELL_VALIDATION_CAPILLARY: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'set_cell_validation_capillary',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SET_RUN_VALIDATION_CAPILLARY: {
    module: ANALYTICS_MODULE.RESULTS,
    action: 'set_run_validation_capillary',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
};
